import { render, staticRenderFns } from "./SvDatePicker.vue?vue&type=template&id=c387f8e0&scoped=true&lang=pug&"
import script from "./SvDatePicker.vue?vue&type=script&lang=js&"
export * from "./SvDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./SvDatePicker.vue?vue&type=style&index=0&id=c387f8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c387f8e0",
  null
  
)

export default component.exports